export default function userDetailReducer(
    state: any = {
        loading : false,
        done    : false,
        userDetail   : null,
        error   : null,
        success : null,
        updated : null,
    },
    action: any) {

    switch (action.type) {

        /**
         *     User detail reducers
         */
        case 'FETCH_USER_DETAIL_PENDING' : {
            return { ...state, loading: true, success : null }
        }

        case 'FETCH_USER_DETAIL_REJECTED' : {
            return { ...state, loading: false, error: action.payload, success : false }
        }

        case 'FETCH_USER_DETAIL_FULFILLED' : {
            return { ...state, loading: false, done: true, error: null, userDetail: action.payload }
        }

        /**
         *     Change account details
         */
        case 'CHANGE_ACCOUNTDETAILS_PENDING' : {
            return { ...state , error: null, success : null }
        }

        case 'CHANGE_ACCOUNTDETAILS_REJECTED' : {
            return { ...state, error: action.payload, success : false,  updated: false }
        }

        case 'CHANGE_ACCOUNTDETAILS_FULFILLED' : {
            return { ...state, error: null, success: true , updated: true }
        }

        /**
         *     Default
         */
        default: {
            return { ...state }
        }

    }

}



// WEBPACK FOOTER //
// ./~/tslint-loader!./src/reducers/userDetail.ts